<template>
  <div id="faq-container" class="faq-page" v-if="!isLoading">
    <c-faq />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import cFaq from '../../components/faq/faqContent.vue'

export default {
  name: 'Faq',
  components: {
    cFaq
  },
  mounted () {
    this.actionPreloader(true)
    setTimeout(() => {
      this.actionPreloader(false)
    }, 2000)
  },
  computed: {
    ...mapState({
      isLoading: state => state.preloader.isLoading
    })
  },
  methods: {
    ...mapActions(['actionPreloader'])
  }
}
</script>
<style lang="scss" scoped>
#team-container{
  padding-top: 96px;
}
</style>
